import { sql } from "drizzle-orm";

import type { WsPAM } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { pipelineArtifactMetadata } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

function transformWsPAM(r: WsPAM) {
  return {
    id: r.id,
    contentId: r.contentId,
    createdAt: r.createdAt,
    updatedAt: r.updatedAt,
    vadResult: null,
  };
}
export async function bulkUpsertPipelineArtifactMetadata(records: WsPAM[]) {
  if (records.length === 0) return;
  const data = records.map((r) => transformWsPAM(r));
  const deduped = deduplicateByKeyValue(data, (item) => item.id);
  await bulkInsert(pipelineArtifactMetadata, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [pipelineArtifactMetadata.id],
      set: {
        contentId: sql`"excluded"."contentId"`,
        updatedAt: sql`"excluded"."updatedAt"`,
        vadResult: sql`"excluded"."vadResult"`,
      },
    },
  });
  emitTableUpdates(["pipeline_artifact_metadata"]);
}
